export default __webpack_public_path__ + "static/media/ic_gmx_40.948d58f5.svg";